import React from "react";
import { useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';


    

const Body = ({sectionallvideoRef,sectionallresourcesRef,hours,allvideolink}) => {
   const { t, i18n } = useTranslation()
            const settings = {
          dots: true,
          infinite: false,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
        };
return (
       <section className="all-training-video">
    <div className="video-title-wrapper">
        <div className="container">
            <h2>{t("All_Training_Videos")}</h2>
        </div>
    </div>
    <div className="video-tab-wrapper" ref={sectionallvideoRef}>
        <div className="container">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="all-hour-tab" data-bs-toggle="tab" data-bs-target="#allhourtab" type="button" role="tab" aria-controls="allhourtab" aria-selected="true">{t('All_Video')}</button>
                </li>
                
                {hours.map((item, index) => (
                <li key={index} className="nav-item" role="presentation">
                  <button className="nav-link" id={'hour-'+item.index} data-bs-toggle="tab" data-bs-target={'#hour'+item.index} type="button" role="tab" aria-controls={'hour'+item.index} aria-selected="false">{item.title}</button>
                </li> 
                ))}
              </ul>
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane show active" id="allhourtab" role="tabpanel" aria-labelledby="all-hour-tab">
                
                    <div className="slider-container all-video-slider">
                    <Slider {...settings}>
                        {allvideolink.map((videolink, index) => (
                            <div className="slide" id={`video-all-`+index}>
                               
                                  { videolink.video_type == 1? <div className="slide-video-content"><iframe title="Video website iframe" width="100%" height="575" src={videolink.video_link} frameBorder="0" allowFullScreen>
                        </iframe></div> :   <div className="slide-video-content"><video width="100%" height="100%" controls class="myVideo" poster={videolink.video_poster}>
                                        <source src={videolink.video_link} type="video/mp4" />
                                        <source src={videolink.video_link} type="video/ogg" />
                                        Your browser does not support HTML video.
                                     </video>
                                     <span className="hour-count-heading">{videolink.hour_name}</span>
                                      <span className="hour-count-title">{videolink.video_title}</span>
                                     <button className="play-button"><img src="video/video-icon.svg" alt=""/></button>
                                     </div>
                                     }                              
                            </div>
                        ))}
                                               
                      </Slider>
                    </div> 
                    
                </div>
                   {hours.map((item, index) => (
                <div key={index} className="tab-pane" id={'hour'+item.index} role="tabpanel" aria-labelledby={'hour-'+item.index}>
                    <div className="slider-container all-video-slider">
                        
                    <Slider {...settings}>
                        {item.video.map((videolink, index) => (
                             <div className="slide" id={`video-all-`+index}>
                               { videolink.video_type == 1? <div className="slide-video-content"><iframe title="Video website iframe" width="100%" height="575" src={videolink.video_link} frameBorder="0" allowFullScreen>
                        </iframe></div> : <div className="slide-video-content">
                                    <video width="100%" height="100%" className="myVideo" poster={videolink.video_poster}>
                                        <source src={videolink.video_link} type="video/mp4"/>
                                        <source src={videolink.video_link} type="video/ogg"/>
                                        Your browser does not support HTML video.
                                     </video>
                                     <span className="hour-count-heading">{videolink.hour_name}</span>
                                      <span className="hour-count-title">{videolink.video_title}</span>
                                     <button className="play-button"><img src="video/video-icon.svg" alt=""/></button>
                                </div>}
                            </div>
                             ))}
                         
                      
                      </Slider>
                    </div> 
                </div>
                ))}
               
              </div>
        </div>
    </div>

  
</section>
  );
};

export default Body;